import React from "react"
import "../landingPage.css"
import TextInput from "../../../components/InputBoxes/TextInput"
const PasswordSection = ({ onChange, value, visible = false }) => {
  return (
    <div
      className={`sliding-panel flex flex-col  ${visible ? "" : "slideData"}`}
    >
      {visible ? (
        <>
         <p className="font-Apparat text-[#424952D9] font-[400] text-[14px] leading-[22px] text-nowrap  mt-[100px]">
        Enter your password
      </p>
      <TextInput
        value={value}
        type="password"
        onChange={onChange}
        inputMode="password"
        placeholder="Password"
        className="max-w-[526px] w-[80dvw] border-0"
        name="password"
      />
      <p className="font-Apparat text-[#424952D9] font-[400] text-[14px] leading-[22px]  text-nowrap text-end cursor-pointer mt-[15px]">
        Forgot password
      </p>
        </>
      ) : null}
    </div>
  )
}

export default PasswordSection
